<template>
  <div>
    <b-card
      header="Plan"
      header-tag="header"
      class="bold-header mt-3"
      header-bg-variant="gray_ligth"
    >
      <div class="form-row">
        <b-form-group
          id="input-group-3"
          label="Nombre del Plan"
          label-for=""
          class="col-md-6"
        >
          <b-input
            class="p-2 px-4 btn-xs"
            readonly
            :value="usuario && usuario.nombre"
          >
          </b-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Tipo"
          label-for="input-2"
          class="col-md-6"
        >
          <b-input
            class="p-2 px-4 btn-xs"
            readonly
            :value="usuario && usuario.tipo"
          >
          </b-input>
        </b-form-group>

        <b-form-group
          id="input-group-3"
          label="Precio"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-input
            id="precio"
            :value="usuario && usuario.precio"
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Numero de Consultas"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-input
            id="email"
            :value="usuario && usuario.nconsultas"
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Descripción"
          label-for="input-1"
          class="col-md-12"
        >
          <b-form-input
            id="yape"
            :value="usuario && usuario.descripcion"
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
      </div>
    </b-card>
    <br />

    <hr />
    <b-card
      header="Suscripción"
      header-tag="header"
      class="bold-header mt-3"
      header-bg-variant="gray_ligth"
    >
      <div class="form-row">
        <b-form-group
          id="input-group-3"
          label="Fecha de Inicio"
          label-for=""
          class="col-md-6"
        >
          <b-input
            class="p-2 px-4 btn-xs"
            readonly
            :value="usuario && usuario.fechainicio"
          >
          </b-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Fecha de Termino"
          label-for="input-2"
          class="col-md-6"
        >
          <b-input
            class="p-2 px-4 btn-xs"
            readonly
            :value="usuario && usuario.fechafin"
          >
          </b-input>
        </b-form-group>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      id_usuario: "",
      usuario: {},
    };
  },
  watch: {},
  created() {},
  computed: {},
  mounted() {
    this.id_usuario = this.$store.state.id_usuario;
    this.CargarDatos();
  },
  methods: {
    CargarDatos() {
      var me = this;
      axios({
        method: "post",
        url: "ApiWeb/PlanUsuarioLista.php",
        data: { id_usuario: me.id_usuario },
      })
        .then((response) => {
          me.usuario = response.data.data;
          //console.log(response.data);
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
  },
};
</script>
<style scoped>
::v-deep .myDiv {
  background-color: #ffffff;
}
.bold-header {
  font-weight: bold; /* Aplica negrita al encabezado */
}
</style>
